export default {
  '功能介绍：支持将烽火数据同步至飞书多维表格': 'Function Introduction: Support synchronizing CRM data to FeiShu multi-dimensional table',
  '重置凭证后，原凭证将会失效，会导致数据表同步失败': 'Resetting the credential will cause the original credential to become invalid, which will cause the data table synchronization to fail',
  '为保证数据安全，谨慎将凭证对外泄露': 'To ensure data security, be cautious when exposing the credential to the public',
  插件名称: 'Plugin Name',
  获取凭证: 'Get Credential',
  重置凭证: 'Reset Credential',
  凭证已复制到粘贴板: 'Credential has been copied to the clipboard',
  '您确定要重置凭证吗，重置后，原凭证将会失效，会导致原多维表格数据同步失败': 'Are you sure you want to reset the credential? After resetting, the original credential will become invalid, which will cause the original multi-dimensional table data synchronization to fail',
  多维表格数据同步插件: 'Multi-dimensional table data synchronization plugin'
};
